import React, { Component } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta, RatatoskRequest, RatatoskResponse, valueByFormikPath, valueNotEmpty } from '../../common'
import { Container, Grid, Message, Segment, Loader } from 'semantic-ui-react'

interface CNCDictListSublemmasProps extends WithTranslation, RouteComponentProps {
    http: AxiosInstance,
    lemma: string,
    sublemma: string,
}

interface CNCDictListSublemmasState {
    sublemmas: string[],
    loading: boolean,
    errorMsg: string
}

class CNCDictListSublemmas extends Component<CNCDictListSublemmasProps, CNCDictListSublemmasState> {

    state = {
        sublemmas: [] as string[],
        loading: false,
        errorMsg: '',
        newTag: ''
    }

    componentDidMount() {
        this.getSublemmata()
    }

    componentDidUpdate(prevProps: Readonly<CNCDictListSublemmasProps>, prevState: Readonly<CNCDictListSublemmasState>, snapshot?: any): void {
        if (this.props.lemma!==prevProps.lemma)
            this.getSublemmata()
    }

    getSublemmata() {
        const { http, lemma, sublemma } = this.props
        let request: RatatoskRequest = {
            query: {
                'type': ':cncdict:form',
                'feats': [
                    {type: ':form:attr:cnc:w:lemma', value: lemma},
                    {__not: {type: ':form:attr:cnc:w:sublemma', value: sublemma}}
                ]
            },
            page: { from: 0, size: 10000 },
            feats: [':form:attr:cnc:w']
        }
        this.setState({loading: true})
        const url = 'cunits/_view'
        this.props.http.post(url, request)
            .then(response => {
                const sublemmas = response.data.data.reduce((acc, u: any) => {
                    const sublemma = u._slots[0]._fillers[0][':form:attr:cnc:w:sublemma']
                    if (!acc.includes(sublemma)) acc.push(sublemma)
                    return acc
                }, [])
                this.setState({sublemmas: sublemmas, errorMsg: '', loading: false})
            }).catch(err => {
                this.setState({loading: false})
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message, loading: false})
                }
            })
    }

    render() {
        const { lemma, t } = this.props
        const { sublemmas, loading } = this.state

        if (!sublemmas.length) return null

        return(
            <Container>
                <strong>{t('Other sublemmas of lemma')} '{lemma}': </strong>
                <>
                {sublemmas.map<React.ReactNode>(s => (
                    <NavLink to={`${s}`}>{s}</NavLink>
                )).reduce((prev, curr) => [prev, ', ', curr])}
                </>
            </Container>
        )
    }

}

export default withTranslation()(CNCDictListSublemmas)